import { Pen } from '../../../../../assets/images';
import ChatMarkdown from '../chat-markdown';

type UserMessageBubbleProps = {
  content: string;
  showEditButton: boolean;
  onEdit: () => void;
};

function UserMessageBubble({ content, showEditButton, onEdit }: UserMessageBubbleProps) {
  return (
    <div className="flex items-end justify-end gap-2 w-full">
      {showEditButton ? (
        <button
          type="button"
          className="edit-icon text-zinc-400 hover:text-zinc-600 p-1 rounded-md hover:bg-zinc-100 shrink-0"
          onClick={onEdit}
          aria-label="Edit query"
        >
          <img src={Pen} alt="pen" width={15} height={15} />
        </button>
      ) : null}
      <div className="chat-user-bubble message-span">
        <ChatMarkdown content={content} className="prose prose-sm max-w-none chat-markdown-root" />
      </div>
    </div>
  );
}

export default UserMessageBubble;
